export class QuotationRequestResponseModel {
    count:number
    next:string
    previous:string
    results: QuotationRequestModel[] 
}


export class QuotationRequestModel {
    id?: number
    request_title: string
    due_date: Date
    status: 'DRAFT' | 'SENT' | 'PARTIALLY_RESPONDED' | 'ALL_RESPONDED' | 'CLOSED'
    general_instructions_for_vendors: string
    created_by: number
    modified_by: number
    outsourcing_form: string
    outsourcing_event_request: number
    created_at: Date
    outsourcing_form_details: any
    modified_at: Date 
    created_by_name: string 
    outsourcing_event_request_details:any
}

